import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AdminTeam } from 'interfaces/admin-teams.interface';
import { initialAdminTeamsState } from 'store/initial-states';
import {
  createAdminTeam,
  fetchAdminTeamsList,
  updateAdminTeam
} from './extra';

const adminTeams = createSlice({
  name: 'adminTeams',
  initialState: initialAdminTeamsState,
  reducers: {
    updateSelectedAdminTeam: (
      state,
      { payload }: PayloadAction<AdminTeam | null>
    ) => {
      state.selectedTeam = payload;
    },
    updateShowAdminTeamFormModal: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.showTeamFormModal = payload;
      if (!payload) {
        state.selectedTeam = null;
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminTeamsList.pending, (state) => {
        state.areTeamsLoading = true;
      })
      .addCase(fetchAdminTeamsList.fulfilled, (state, { payload }) => {
        state.teams = payload?.teams ?? [];
        state.totalCount = payload?.total_count ?? 0;
        state.areTeamsLoading = false;
      })
      .addCase(fetchAdminTeamsList.rejected, (state) => {
        state.areTeamsLoading = false;
      })
      .addCase(createAdminTeam.pending, (state) => {
        state.isSavingTeam = true;
      })
      .addCase(createAdminTeam.fulfilled, (state) => {
        state.isSavingTeam = false;
      })
      .addCase(createAdminTeam.rejected, (state) => {
        state.isSavingTeam = false;
      })
      .addCase(updateAdminTeam.pending, (state) => {
        state.isSavingTeam = true;
      })
      .addCase(updateAdminTeam.fulfilled, (state) => {
        state.isSavingTeam = false;
      })
      .addCase(updateAdminTeam.rejected, (state) => {
        state.isSavingTeam = false;
      });
  }
});

export const { updateSelectedAdminTeam, updateShowAdminTeamFormModal } =
  adminTeams.actions;

export default adminTeams.reducer;
